import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasPhoto = createSelector(selectJsonQuery, jsonQuery => getTermValue('wp')(jsonQuery));
